import type { BlogPost } from '../types';

export const seedBlogPosts: BlogPost[] = [
  {
    id: 1,
    slug: 'tdcs-nedir',
    title: 'tDCS Nedir? Evde Kullanım Rehberi',
    excerpt:
      'Transkraniyal doğru akım stimülasyonu (tDCS) hakkında temel bilgiler ve güvenli kullanım önerileri.',
    content:
      'tDCS, düşük yoğunluklu doğru akımın kafa derisi üzerinden uygulandığı bir nöromodülasyon yöntemidir.\n\nEvde kullanım öncesinde cihazın kullanım kılavuzunu okumanız ve uygun protokolleri takip etmeniz önerilir.\n\nHerhangi bir sağlık sorununuz varsa kullanıma başlamadan önce hekiminize danışın.',
    author: 'HealthShopLongevity',
    isPublished: true,
    publishedAt: '2026-09-01T09:00:00.000Z',
    createdAt: '2026-09-01T09:00:00.000Z',
    updatedAt: '2026-09-01T09:00:00.000Z',
  },
  {
    id: 2,
    slug: 'hidrojenli-su-faydalari',
    title: 'Hidrojenli Su ve Antioksidan Destek',
    excerpt: 'Hidrojen konsantrasyonu, günlük kullanım ve dikkat edilmesi gereken noktalar.',
    content:
      'Hidrojenli su, moleküler hidrojen içeren ve antioksidan destek amacıyla tüketilen bir içecektir.\n\nDüzenli kullanımda su kalitesi ve cihaz bakımı önemlidir.\n\nTıbbi bir tedavi yerine geçmez; dengeli beslenme ve yaşam tarzı ile birlikte değerlendirilmelidir.',
    author: 'HealthShopLongevity',
    isPublished: true,
    publishedAt: '2026-09-05T10:00:00.000Z',
    createdAt: '2026-09-05T10:00:00.000Z',
    updatedAt: '2026-09-05T10:00:00.000Z',
  },
];
